import React, { useState } from "react";
import config from "../../../config";
import TextArea from "../../TextArea/TextArea";
import "../Modal2.css";
import { authFetch } from "../../../utils/Security/authFetch";

type JournalModalProps = {
  data: {
    ticketId: string;
    problemCloseDatetime?: string;
    errorType?: string;
    closureCode?: string;
    solution?: string;
  };
  onConfirm: () => void;
  onCancel: () => void;
  title?: string; // optional prop
};

const JournalModal: React.FC<JournalModalProps> = ({
  data,
  onConfirm,
  onCancel,
  title,
}) => {
  const [solution, setSolution] = useState<string>(data.solution || "");

  const postMessage = async (payload: any) => {
    const res = await authFetch(`${config.apiBaseUrl}/api/messages`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || "Failed to post message");
    }

    return res;
  };

  const handleConfirm = async () => {
    if (!solution.trim()) {
      alert("Please enter a journal note before submitting.");
      return;
    }

    const username = localStorage.getItem("username") || "System";
    const payload = {
      username,
      message: `ID : ${data.ticketId} ${solution}`,
      date: new Date().toISOString(),
      read: false,
      ticketId: data.ticketId,
    };
    localStorage.setItem("comment", solution);
    try {
      await postMessage(payload);
      alert("Journal Added Successfully!");
      onConfirm();
    } catch (error) {
      alert(`Failed to Add Journal: ${(error as Error).message}`);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          padding: "2rem 2.5rem",
          borderRadius: "12px",
          maxWidth: 450,
          width: "100%",
          boxShadow:
            "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontWeight: 600,
            fontSize: "1.5rem",
            color: "#333",
          }}
        >
          {title || "Add Journal"}
        </h2>

        <TextArea
          label="Journal"
          onChange={setSolution}
          style={{ width: "100%", height: "300px" }}
          value={""}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={() => {
              //console.log("Journal modal closed by user.");
              onCancel();
            }}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#444",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f0f0f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff")
            }
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#f97316",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 4px 8px rgba(249, 115, 22, 0.4)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#c4510b")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f97316")
            }
          >
            Add Journal
          </button>
        </div>
      </div>
    </div>
  );
};

export default JournalModal;
